/**
 * ルートパス生成ユーティリティ
 * 評価関連のルートパスを動的に生成する
 */

/**
 * 上長評価一覧ページのパスを生成
 */
export const getManagerEvaluationListPath = (periodId: string) => {
  return `/manager-evaluation/${periodId}`;
};

/**
 * 上長評価フォームページのパスを生成
 */
export const getManagerEvaluationFormPath = (employeeId: string, periodId: string) => {
  return `/manager-evaluation/${employeeId}/${periodId}`;
};

/**
 * 部門長評価一覧ページのパスを生成
 */
export const getDeptHeadEvaluationListPath = (periodId: string) => {
  return `/dept-head-evaluation/${periodId}`;
};

/**
 * 部門長評価フォームページのパスを生成
 */
export const getDeptHeadEvaluationFormPath = (employeeId: string, periodId: string) => {
  return `/dept-head-evaluation/${employeeId}/${periodId}`;
};

/**
 * HR評価詳細ページのパスを生成
 */
export const getHREvaluationDetailPath = (employeeId: string, periodId: string) => {
  return `/hr/evaluations/${employeeId}/${periodId}`;
};

/**
 * ダッシュボードパス
 */
export const DASHBOARD_PATH = '/dashboard';

/**
 * 自己評価パス
 */
export const SELF_EVALUATION_PATH = '/evaluation/self';

export const GOAL_SETTING_PATH = '/evaluation/goals';

export const GOAL_APPROVAL_PATH = '/evaluation/goals/approval';

/**
 * レポートパス
 */
export const REPORTS_PATH = '/reports';

/**
 * プロフィールパス
 */
export const PROFILE_PATH = '/profile';

/**
 * HR評価管理パス
 */
export const HR_EVALUATIONS_PATH = '/hr/evaluations';

/**
 * 管理機能パス
 */
export const ADMIN_PATHS = {
  users: '/admin/users',
  departments: '/admin/departments',
  positions: '/admin/positions',
  jobTitles: '/admin/job-titles',
  rankCost: '/admin/rank-cost',
  evaluationPeriods: '/admin/evaluation-periods',
  evaluationItems: '/admin/evaluation-items',
  evaluationRoutes: '/admin/evaluation-routes',
  rValue: '/admin/r-value',
  skillMaster: '/admin/skills/master',
  permissions: '/admin/permissions', // 機能権限指定（統合）
  auditLogs: '/admin/audit-logs', // 監査ログ
} as const;

/**
 * スキル関連パス
 */
export const SKILL_PATHS = {
  mySkills: '/skills/my-skills',
  approval: '/skills/approval',
  history: '/skills/history',
  visualization: '/skills/visualization',
} as const;

/**
 * プロジェクト歴関連パス
 */
export const PROJECT_PATHS = {
  myProjects: '/projects/my-projects',
  approval: '/projects/approval',
} as const;

/**
 * 資格情報関連パス
 */
export const CERTIFICATION_PATHS = {
  myCertifications: '/certifications/my-certifications',
  approval: '/certifications/approval',
} as const;

/**
 * 営業管理関連パス
 */
export const SALES_PATHS = {
  cases: '/sales/cases',
  kpi: '/sales/kpi',
  accounts: '/sales/accounts',
  snapshots: '/sales/snapshots',
} as const;
